import { Edit } from "@mui/icons-material";
import {
  Typography,
  Paper,
  Box,
  Grid,
  Link,
  Stack,
  IconButton,
} from "@mui/material";

export default function ViewFiles(props) {
  return (
    <Box style={{ marginTop: 30 }} sx={{ flexGrow: 1 }}>
      {props.viewFiles.length === 0 ? (
        <Stack
          style={{ paddingTop: 30 }}
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography>
            There aren't any files associated with this
            {props.equipmentId
              ? " equipment"
              : props.issueId
              ? " issue"
              : props.observationId
              ? " observation"
              : "project"}
            . Please Edit
            <IconButton
              onClick={props.onEditClick}
              aria-label="Add Issue"
              size="medium"
              color="primary"
            >
              <Edit fontSize="inherit" />
            </IconButton>
            this{" "}
            {props.equipmentId
              ? " equipment"
              : props.issueId
              ? " issue"
              : props.observationId
              ? " observation"
              : "project"}{" "}
            to add new Files.
          </Typography>
        </Stack>
      ) : (
        <Grid container spacing={2}>
          {props.viewFiles
            .filter((x) => x.deleted === false)
            .map((f, idx) => (
              <Grid key={idx} size={{ xs: 12, sm: 3 }}>
                {f.file.startsWith("data:image/") ||
                [
                  ".jpg",
                  "jpeg",
                  ".png",
                  ".gif",
                  ".bmp",
                  "webp",
                  ".svg",
                ].includes(
                  f.file.split("?alt=media")[0].slice(-4).toLowerCase()
                ) ? (
                  <Paper elevation={6} style={{ marginTop: 30, padding: 16 }}>
                    <div style={{ position: "relative" }}>
                      {/* <Tooltip
                      style={{
                        position: "absolute",
                        margin: 8,
                        backgroundColor: "lightgray",
                      }}
                      title="Remove File"
                    >
                      <IconButton
                        aria-label="Remove"
                        color="primary"
                        onClick={() => props.onRemoveEditFile(f.id)}
                      >
                        <ClearIcon />
                      </IconButton>
                    </Tooltip> */}
                      <img
                        alt={f.name}
                        src={f.file}
                        style={{ maxHeight: 300, maxWidth: "100%" }}
                      />
                    </div>

                    <div key={idx}>
                      <Typography
                        color="primary.light"
                        variant="subtitle1"
                        gutterBottom
                      >
                        {"File Comment"}
                      </Typography>
                      <Typography variant="subtitle1" gutterBottom>
                        {f.comment.length === 0 ? "Null" : f.comment}
                      </Typography>
                    </div>
                  </Paper>
                ) : (
                  <Paper elevation={6} style={{ marginTop: 30, padding: 16 }}>
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Link href={f.file} variant="body2">
                        {f.name}
                      </Link>
                      {/* <Tooltip
                      style={{
                        margin: 8,
                        backgroundColor: "lightgray",
                      }}
                      title="Remove File"
                    >
                      <IconButton
                        aria-label="Remove"
                        color="primary"
                        onClick={() => props.onRemoveEditFile(f.id)}
                      >
                        <ClearIcon />
                      </IconButton>
                    </Tooltip> */}
                    </Stack>
                    <div key={idx}>
                      <Typography
                        color="primary.light"
                        variant="subtitle1"
                        gutterBottom
                      >
                        {"Comment"}
                      </Typography>
                      <Typography variant="subtitle1" gutterBottom>
                        {f.comment.length === 0 ? "Null" : f.comment}
                      </Typography>
                    </div>
                  </Paper>
                )}
              </Grid>
            ))}
        </Grid>
      )}
    </Box>
  );
}
